module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-grey"
  }, [_c('div', {
    staticClass: "pa-4 display-flex justify-end"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/mobile/icon/close_circle.svg"),
      "width": "40",
      "height": "40"
    },
    on: {
      "click": function($event) {
        _vm.$emit('previousStep')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bg-white pa-4 payment"
  }, [_c('div', {
    staticClass: "font-24 font-weight-600 text-black"
  }, [_vm._v("Loud Pack")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text-poppins-14 font-weight-600 text-black my-4"
  }, [_vm._v("\n      You have of multiple memberships for this user. You can keep or cancel\n      other memberships.\n    ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('v-btn', {
    staticClass: "text-poppins-14 text-white font-weight-700 btn-pay ma-0 full-width my-4",
    on: {
      "click": function($event) {
        _vm.$emit('nexStep')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/mobile/icon/apple-pay.svg"),
      "width": "58",
      "height": "24"
    }
  })]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 font-weight-700 mb-2"
  }, [_vm._v("Credit card")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "text-dmsans-14 font-weight-700 mb-2"
  }, [_vm._v("Country or region")]), _vm._v(" "), _c('div', {
    staticClass: "mb-4 country-region"
  }, [_c('v-select', {
    staticClass: "pt-0 country",
    attrs: {
      "label": "Choose one",
      "single-line": "",
      "hide-details": ""
    }
  }), _vm._v(" "), _vm._m(6)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "text-poppins-18 btn-confirm ma-0 text-white full-width",
    on: {
      "click": function($event) {
        _vm.$emit('nexStep')
      }
    }
  }, [_vm._v("\n      Pay\n    ")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    staticClass: "font-20 font-weight-600 text-black"
  }, [_vm._v("20$/")]), _vm._v(" "), _c('span', {
    staticClass: "text-poppins-14 font-weight-600 text-black"
  }, [_vm._v("month")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between mb-2"
  }, [_c('span', {
    staticClass: "text-poppins-16 font-weight-600 text-black"
  }, [_vm._v(" Gold")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between mb-2"
  }, [_c('span', {
    staticClass: "text-poppins-16 font-weight-600 text-black"
  }, [_vm._v("\n        Platinum")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "display-flex justify-space-between mb-2"
  }, [_c('span', {
    staticClass: "text-poppins-16 font-weight-600 text-black"
  }, [_vm._v("\n        Sample packs\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "slider round"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-dmsans-16 text-grey-3 font-weight-400 display-flex align-center full-width mt-2 mb-4"
  }, [_c('hr', {
    staticClass: "flex-grow"
  }), _vm._v(" "), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("Or pay with card")]), _vm._v(" "), _c('hr', {
    staticClass: "flex-grow"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "credit-card mb-5"
  }, [_c('div', {
    staticClass: "display-flex align-center px-3 credit-card__number"
  }, [_c('input', {
    staticClass: "full-width border-none",
    attrs: {
      "type": "text",
      "placeholder": "1234 1234 1234 1234"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center gap-8"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/mobile/icon/visa.svg"),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../assets/mobile/icon/master-card.svg"),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../assets/mobile/icon/american-express.svg"),
      "width": "24",
      "height": "16"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../assets/mobile/icon/discover.svg"),
      "width": "24",
      "height": "16"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "display-flex align-center full-width"
  }, [_c('input', {
    staticClass: "border-none width-50 credit-card__month px-3 credit-card__month",
    attrs: {
      "type": "text",
      "placeholder": "MM / YY"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "width-50 px-3 display-flex align-center"
  }, [_c('input', {
    staticClass: "border-none full-width",
    attrs: {
      "type": "text",
      "placeholder": "CVC"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../../../assets/mobile/icon/card.svg"),
      "width": "24",
      "height": "16"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zip"
  }, [_c('input', {
    staticClass: "full-width border-none px-3",
    attrs: {
      "type": "text",
      "placeholder": "ZIP"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35977910","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/new-mobile/components/plan-detail/payment.vue
// module id = 1678
// module chunks = 180